import { useNavigate } from 'react-router';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table';
import { Badge } from '@/components/ui/badge';
import type { DashboardStudentItem } from '@/types/dashboard';
import { formatDate, formatPercent } from '@/lib/utils';

interface StudentsTableProps {
  students: DashboardStudentItem[];
}

export function StudentsTable({ students }: StudentsTableProps) {
  const navigate = useNavigate();

  return (
    <div className="rounded-md border">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>Name</TableHead>
            <TableHead>Email</TableHead>
            <TableHead>Joined</TableHead>
            <TableHead>Assignments</TableHead>
            <TableHead>Completion</TableHead>
            <TableHead>Streak</TableHead>
            <TableHead>Last Activity</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {students.length === 0 ? (
            <TableRow>
              <TableCell colSpan={7} className="text-center text-muted-foreground">
                No students found.
              </TableCell>
            </TableRow>
          ) : (
            students.map((s) => (
              <TableRow
                key={s.id}
                className="cursor-pointer"
                onClick={() => navigate(`/students/${s.id}`)}
              >
                <TableCell className="font-medium">
                  {[s.first_name, s.last_name].filter(Boolean).join(' ') || s.username || '—'}
                </TableCell>
                <TableCell>{s.email ?? '—'}</TableCell>
                <TableCell>{formatDate(s.joined_at)}</TableCell>
                <TableCell>
                  {s.assignments_completed}/{s.assignments_total}
                </TableCell>
                <TableCell>{formatPercent(s.completion_rate)}</TableCell>
                <TableCell>
                  <Badge variant={s.current_streak > 0 ? 'default' : 'secondary'}>
                    {s.current_streak}d
                  </Badge>
                </TableCell>
                <TableCell>
                  {s.last_activity ? formatDate(s.last_activity) : '—'}
                </TableCell>
              </TableRow>
            ))
          )}
        </TableBody>
      </Table>
    </div>
  );
}
